import Cookies from 'cookies-js'


export function setCookieValue(name,value) {
  return Cookies.set(name,value);
}

export function getCookieValue(name) {
  return Cookies.get(name);
}

export function setName(name) {
  return Cookies.set('name',name);
}

export function getName() {
  return Cookies.get('name');
}

export function setToken(token,autoLogin) {
  if (autoLogin) {
    return Cookies.set("token",token,{expires: 7});
  } else {
    return Cookies.set("token",token);
  }
}

export function getToken() {
  let uToken = Cookies.get("token");

  if (!uToken) {
    uToken = false;
  }

  return uToken;
}

export function setUserInfo(userInfo) {
  return Cookies.set("userInfo",userInfo);
}

export function getUserInfo() {
  let uInfo = Cookies.get('userInfo');

  if (!uInfo) {
    uInfo = false;
  }

  return uInfo;
}


// WEBPACK FOOTER //
// ./src/utils/auth.js